import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import ServiceDetailPage from "@/pages/ServiceDetail";

export const Route = createFileRoute("/$lang/services/$slug")({
  head: ({ params }) => pageHead(params.lang, "services", params.slug),
  component: ServiceDetailPage,
});
